<template>
  <div class="text-center">
    <v-dialog
      v-model="visibility"
      width="500"
      v-if="userProfile"
    >
      <v-card v-if="!newAddress">
        <v-card-text class="text-center">
            <p class="py-12 mx-10">

                Deseja fazer a aula em um endereço diferente do que está salvo?
                <br /><br/>
                <v-btn @click="setDifferentAddress" rounded color="grey" outlined>Usar outro endereço</v-btn>
            </p>

            <hr style="border: none; border-top: 2px solid #bfb5c9;" class="mx-10">

            <p class="py-12 mx-10 mb-0">
                <v-btn @click="openHomeSchool" large color="secondary" rounded depressed style="color: #440099;" class="mb-3">Usar endereço salvo</v-btn>
                <br />

                {{ userProfile.street }}, {{ userProfile.number }}
                <br /> {{ userProfile.neighborhood }}
            </p>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-text class="text-center">
          <p class="pt-8">Aonde você deseja fazer esta aula?</p>
            <v-form style="max-width: 300px;" class="mx-auto">
                <v-col col-12>
                    <v-text-field
                    v-model="form.cep"
                    label="CEP do local"
                    autofocus
                    maxlength="9"
                    class="pt-0 pb-8"
                    ></v-text-field>
                </v-col>

                <!-- <hr style="border: none; border-top: 2px solid #bfb5c9;" class="mx-12"> -->

                <v-col col-12 class="pt-0">
                    <v-text-field
                    v-model="form.city"
                    label="Cidade"
                    class="py-0 mb-0"
                    ></v-text-field>
                </v-col>

                <v-col col-12 class="pt-0">
                    <v-text-field
                    v-model="form.neighborhood"
                    label="Bairro"
                    class="py-0 my-0"
                    ></v-text-field>
                </v-col>

                <v-col col-12 class="pt-0">
                    <v-text-field
                    v-model="form.street"
                    label="Rua"
                    class="py-0 my-0"
                    ></v-text-field>
                </v-col>

                <v-col col-12 class="pt-0">
                    <v-text-field
                    v-model="form.number"
                    label="Numero"
                    class="py-0 my-0"
                    ></v-text-field>
                </v-col>

                <v-col col-12 class="pt-0">
                    <v-text-field
                    v-model="form.complement"
                    label="Complemento"
                    hint="ex.: Bloco D apto 504"
                    persistent-hint
                    class="py-0 my-0"
                    ></v-text-field>
                </v-col>
                <v-btn @click="useNewAddress" large color="secondary" rounded depressed style="color: #440099;" class="mb-3 mt-6">Usar este endereço</v-btn>
            </v-form>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogMixin from "@/mixins/dialogs/DialogMixin";
import axios from "axios";
import { mapState, mapMutations } from 'vuex';
import ProfileRepository from '@/repositories/ProfileRepository';

export default {
  mixins: [DialogMixin],
  data() {
    return {
      defaultForm: {
        cep: undefined,
        city: undefined,
        neighborhood: undefined,
        street: undefined,
        number: undefined,
        complement: undefined,
      },
      newAddress: false
    };
  },
  computed: {
    ...mapState(['userProfile'])
  },
  watch: {
    async 'form.cep'(newVal) {
      if (newVal.length === 8) {
        const response = await axios({
          url: `https://viacep.com.br/ws/${newVal}/json/`,
          method: 'get',

        })

        console.log("?????????????????")
        console.log( response.data )
        console.log("?????????????????")

        this.form.cep = response.data.cep;
        this.form.city = response.data.localidade;
        this.form.street = response.data.logradouro;
        this.form.neighborhood = response.data.bairro;
        this.form.state = response.data.uf
      }
    },
    visibility: {
      immediate: true,
      handler(newValue) {
        if (this.userProfile && !this.userProfile.street) {
          this.newAddress = true;
        }
      }
    }
  },
  methods: {
    setDifferentAddress() {
      this.newAddress = !this.newAddress
    },

    async useNewAddress() {
      const response = await ProfileRepository.update_address(this.form, this.userProfile.id )
      this.openHomeSchool()
    },
    openHomeSchool() {
      this.$emit('negative')
      this.setHomeSchool(true)
    },
    ...mapMutations(["setHomeSchool"])
  },
}
</script>